import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import IconOrtodoncia from "assets/img/dentist-icons/Asset 4.svg";
import IconOrtopedia from "assets/img/dentist-icons/Asset 16.svg";
import IconEndodoncia from "assets/img/dentist-icons/Asset 12.svg";
import IconPeriodoncia from "assets/img/dentist-icons/Asset 3.svg";
import IconDisenio from "assets/img/dentist-icons/Asset 9.svg";
import IconRehabilitacion from "assets/img/dentist-icons/Asset 13.svg";
import IconCirugia from "assets/img/dentist-icons/Asset 15.svg";

const services = [
  {
    icon: IconOrtodoncia,
    title: "Ortodoncia",
    desc: "Corregimos la posición de tus dientes abordando el tratamiento según tu necesidad, tratamientos veloces con brackets de autoligado, totalmente invisibles como lo son la ortodoncia lingual o con alineadores, o más versátiles como los brackets convencionales en su versiones estéticas o metálicas."
  },
  {
    icon: IconOrtopedia,
    title: "Ortopedia maxilar",
    desc: "Es un tratamiento para niños en crecimiento que ayuda a guiar el desarrollo de los maxilares y prevenir problemas futuros de mordida o posición dental. Se trabaja de forma integral, corrigiendo hábitos nocivos como la respiración bucal o la succión del dedo, y buscando un buen equilibrio funcional y postural."
  },
  {
    icon: IconEndodoncia,
    title: "Endodoncia",
    desc: "También conocida como tratamiento de conducto, se realiza cuando el nervio del diente está dañado por caries profundas, traumatismos o infecciones. Este tratamiento permite eliminar el dolor y representa la última oportunidad para salvar el diente antes de considerar una extracción."
  },
  {
    icon: IconPeriodoncia,
    title: "Periodoncia",
    desc: "La periodoncia es la especialidad que cuida las encías y los tejidos de sostén del diente. Prevenimos enfermedades y tratamos problemas como inflamación, sangrado o pérdida ósea, además de corregir hábitos que afectan la salud bucal para mantener una boca sana y funcional."
  },
  {
    icon: IconDisenio,
    title: "Diseño de sonrisa",
    desc: "Es un tratamiento personalizado que busca mejorar la apariencia de tu sonrisa, combinando estética y función. Se evalúan aspectos como la forma, color y posición de los dientes, así como la armonía con tus labios y rostro, para lograr una sonrisa natural y atractiva."
  },
  {
    icon: IconRehabilitacion,
    title: "Rehabilitación",
    desc: "Tratamientos que recuperan la función, salud y estética de tu boca cuando faltan o están dañados uno o varios dientes. Incluye desde prótesis, implantes, coronas hasta restauraciones para que puedas masticar bien, hablar con comodidad y lucir una sonrisa saludable."
  },
  {
    icon: IconCirugia,
    title: "Cirugía dentoalveolar",
    desc: "Son procedimientos quirúrgicos que incluyen extracciones simples o complejas de órganos dentales, además de la preparación del lecho óseo para tratamientos como implantes, prótesis, coronas y otros."
  }
];

export default function Services() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = idx => setOpenIndex(current => (current === idx ? null : idx));

  return (
    <div className="section" id="services">
      <Container>
        <Row className="justify-content-center">
          <Col md="8" className="text-center">
            <h2 className="section-title reveal">Nuestros servicios</h2>
            <p className="section-lead reveal">
              Cuidamos tu sonrisa con tecnología de vanguardia y atención personalizada
            </p>
          </Col>
        </Row>
        <Row>
          {services.map((s, i) => {
            const isOpen = openIndex === i;
            return (
              <Col md="6" lg="4" xs="12" key={s.title} className="mb-4 d-flex reveal">
                <div
                  className={`service-card${isOpen ? " is-open" : ""}`}
                  onClick={() => toggle(i)}
                  onKeyDown={e => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      toggle(i);
                    }
                  }}
                  tabIndex={0}
                  role="button"
                  aria-expanded={isOpen}
                >
                  <div className="icon-container">
                    <img src={s.icon} alt="" aria-hidden="true" />
                  </div>
                  <h3>{s.title}</h3>
                  <p className="service-desc">{s.desc}</p>
                  <span className="service-toggle">
                    {isOpen ? "Ver menos" : "Ver más"}
                  </span>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}
